document.addEventListener("DOMContentLoaded", function() {
  function getVariantOption(v, pos) {
    if (pos === 0) return v.option1;
    if (pos === 1) return v.option2;
    if (pos === 2) return v.option3;
    return null;
  }

  function parseCardData(card) {
    var script = card.querySelector(".js-product-card-data");
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function variantMatches(v, selections, numOptions) {
    for (var i = 0; i < numOptions; i++) {
      var s = selections[i];
      if (s == null || s === "") continue;
      var vo = getVariantOption(v, i);
      if (vo !== s) return false;
    }
    return true;
  }

  function findMatchingVariant(variants, selections, numOptions, data) {
    var exact = variants.find(function(v) {
      return variantMatches(v, selections, numOptions);
    });
    if (exact) return exact;
    var colorPos = data.colorPosition;
    if (data.hasBwSwitch && colorPos !== null && colorPos !== undefined) {
      var relaxed = variants.find(function(v) {
        for (var i = 0; i < numOptions; i++) {
          if (i === colorPos) continue;
          var s = selections[i];
          if (s == null || s === "") continue;
          if (getVariantOption(v, i) !== s) return false;
        }
        return true;
      });
      if (relaxed) return relaxed;
    }
    return variants[0] || null;
  }

  function getVariantById(card, data) {
    var id = parseInt(card.dataset.variantId, 10);
    return data.variants.find(function(x) { return x.id === id; }) || data.variants[0];
  }

  function getSelectionsFromCard(card, data) {
    var sel = [null, null, null];
    var currentV = getVariantById(card, data);
    for (var o = 0; o < data.options.length; o++) {
      var opt = data.options[o];
      var pos = opt.position;
      if (opt.type === "color_bw") {
        var toggle = card.querySelector(".js-color-switch");
        var isWhite = !toggle || toggle.getAttribute("aria-pressed") === "true";
        sel[pos] = isWhite ? data.colorWhiteValue : data.colorBlackValue;
      } else {
        var selectEl = card.querySelector('.js-product-option-select[data-option-position="' + pos + '"]');
        if (selectEl) sel[pos] = selectEl.value;
        else if (currentV) sel[pos] = getVariantOption(currentV, pos);
      }
    }
    return sel;
  }

  function syncToggleFromVariant(card, data, v) {
    if (!data.hasBwSwitch || data.colorPosition === null || data.colorPosition === undefined) return;
    var toggle = card.querySelector(".js-color-switch");
    var wrap = card.querySelector(".color-switch");
    if (!toggle || !v) return;
    var cv = getVariantOption(v, data.colorPosition);
    var isWhite = data.colorWhiteValue != null && cv === data.colorWhiteValue;
    toggle.setAttribute("aria-pressed", isWhite ? "true" : "false");
    if (wrap) wrap.classList.toggle("color-switch--white", isWhite);
    var t = window.productMixTranslations || {};
    var switchTo = (t && t.switch_to) ? t.switch_to : "Switch to";
    var blackLabel = (wrap && wrap.querySelector(".color-switch__label--black")) ? wrap.querySelector(".color-switch__label--black").textContent : "Black";
    var whiteLabel = (wrap && wrap.querySelector(".color-switch__label--white")) ? wrap.querySelector(".color-switch__label--white").textContent : "White";
    toggle.setAttribute("aria-label", isWhite ? switchTo + " " + blackLabel : switchTo + " " + whiteLabel);
  }

  function applyVariantToCard(card) {
    var data = parseCardData(card);
    if (!data || !data.variants || !data.variants.length) return;
    var numOpts = data.numOptions || data.options.length;
    var sel = getSelectionsFromCard(card, data);
    var v = findMatchingVariant(data.variants, sel, numOpts, data);
    if (!v) return;
    card.dataset.variantId = String(v.id);
    var img = card.querySelector(".js-product-card-img");
    if (img && v.featured_image) img.src = v.featured_image;
    var priceEl = card.querySelector(".js-product-card-price");
    if (priceEl && v.price_money) priceEl.textContent = v.price_money;
    syncToggleFromVariant(card, data, v);
    if (typeof updateSummary === "function") updateSummary();
    if (typeof updateTravelExpense === "function") updateTravelExpense();
  }

  function initProductCardOptions(card) {
    var data = parseCardData(card);
    if (!data || !data.variants || !data.variants.length) return;
    var v = data.variants.find(function(x) { return x.id === data.initialVariantId; }) || data.variants[0];
    if (!v) return;
    card.dataset.variantId = String(v.id);
    data.options.forEach(function(opt) {
      if (opt.type !== "color_bw") {
        var selectEl = card.querySelector('.js-product-option-select[data-option-position="' + opt.position + '"]');
        if (selectEl) {
          var val = getVariantOption(v, opt.position);
          if (val != null) selectEl.value = val;
        }
      }
    });
    applyVariantToCard(card);
  }

  document.addEventListener("click", function(e) {
    var btn = e.target.closest(".js-color-switch");
    if (!btn) return;
    var card = btn.closest(".product-card");
    if (!card) return;
    e.preventDefault();
    e.stopPropagation();
    var isWhite = btn.getAttribute("aria-pressed") === "true";
    var newIsWhite = !isWhite;
    btn.setAttribute("aria-pressed", newIsWhite);
    var wrap = card.querySelector(".color-switch");
    if (wrap) wrap.classList.toggle("color-switch--white", newIsWhite);
    var t = window.productMixTranslations || {};
    var switchTo = (t && t.switch_to) ? t.switch_to : "Switch to";
    var blackLabel = (wrap && wrap.querySelector(".color-switch__label--black")) ? wrap.querySelector(".color-switch__label--black").textContent : "Black";
    var whiteLabel = (wrap && wrap.querySelector(".color-switch__label--white")) ? wrap.querySelector(".color-switch__label--white").textContent : "White";
    btn.setAttribute("aria-label", newIsWhite ? switchTo + " " + blackLabel : switchTo + " " + whiteLabel);
    applyVariantToCard(card);
  });

  document.addEventListener("change", function(e) {
    if (!e.target.classList || !e.target.classList.contains("js-product-option-select")) return;
    var card = e.target.closest(".product-card");
    if (card) applyVariantToCard(card);
  });

  const plusButtons = document.querySelectorAll(".js-plus");
  const minusButtons = document.querySelectorAll(".js-minus");
  const totalCountEl = document.querySelector(".total-count");
  const mtotalCountEl = document.querySelector(".mob-total-count");
  const summaryList = document.querySelector(".bundle-product-list product-mm-list");
  const discountText = document.querySelector(".text-percentage-wrap span");
  const discountInfo = document.querySelector(".text-percentage-wrap p");
  const addToCartBtn = document.querySelector(".nws-submit-btn");
  const addToCartBtnText = addToCartBtn.querySelector("span");
  const progressBar = document.querySelector(".text-percentage-wrap");

  const bundleSteps = document.querySelectorAll("[data-bundel-step]");
  let totalPrice = 0;
  let discount = 0;

 
  addToCartBtn.disabled = true;
  addToCartBtn.classList.add("disabled");
  addToCartBtnText.textContent = (window.productMixTranslations && window.productMixTranslations.add_1_product) || "ADD 1 PRODUCT";

  // Travel expense - steps from product variants (e.g. 20, 30, 40, 45, 50, 60, 70, 80, 90, 100)
  const travelWrap = document.querySelector(".travel-expense-wrap");
  const travelCheckbox = travelWrap ? travelWrap.querySelector(".js-travel-expense-checkbox") : null;
  const travelContent = travelWrap ? travelWrap.querySelector(".js-travel-expense-content") : null;
  let travelVariants = {};
  let travelSteps = [];
  if (travelWrap) {
    try {
      travelVariants = JSON.parse(travelWrap.dataset.variants || "{}");
      travelSteps = Object.keys(travelVariants).map(Number).filter(function(k) { return !isNaN(k); }).sort(function(a, b) { return a - b; });
    } catch (e) {}
  }

  function isTravelExpenseEnabled() {
    return travelCheckbox && travelCheckbox.checked;
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace(".", ",") + " €";
  }

  function roundToNearestStep(val) {
    if (travelSteps.length === 0) return val;
    var min = travelSteps[0];
    var max = travelSteps[travelSteps.length - 1];
    var clamped = Math.max(min, Math.min(max, val));
    var nearest = travelSteps[0];
    var bestDiff = Infinity;
    for (var i = 0; i < travelSteps.length; i++) {
      var d = Math.abs(travelSteps[i] - clamped);
      if (d < bestDiff) {
        bestDiff = d;
        nearest = travelSteps[i];
      }
    }
    return nearest;
  }

  function getTravelVariantForKm(km) {
    if (travelSteps.length === 0) return null;
    var rounded = roundToNearestStep(km);
    return travelVariants[String(rounded)] || null;
  }

  function buildTravelScale() {
    var scaleEl = travelWrap && travelWrap.querySelector(".js-travel-scale");
    if (!scaleEl || travelSteps.length === 0) return;
    if (scaleEl.children.length > 0) return;
    var maxIdx = travelSteps.length - 1;
    travelSteps.forEach(function(km, i) {
      var pip = document.createElement("div");
      pip.className = "travel-expense-pip travel-expense-pip--major";
      pip.style.left = (maxIdx > 0 ? (i / maxIdx) * 100 : 0) + "%";
      pip.innerHTML = "<span class=\"travel-expense-pip-marker\"></span><span class=\"travel-expense-pip-value\">" + km + "</span>";
      scaleEl.appendChild(pip);
    });
  }

  function updateTravelExpense() {
    if (!travelWrap) return;
    var enabled = isTravelExpenseEnabled();
    if (travelContent) {
      travelContent.hidden = !enabled;
    }

    var kmInput = travelWrap.querySelector(".js-travel-km-input");
    var rangeInput = travelWrap.querySelector(".js-travel-range");
    var tooltipEl = travelWrap.querySelector(".js-travel-tooltip");
    var priceEl = travelWrap.querySelector(".js-travel-price");
    var travelTotalEl = travelWrap.querySelector(".js-travel-total");
    var productsSubtotalEl = travelWrap.querySelector(".js-products-subtotal");
    var grandTotalEl = travelWrap.querySelector(".js-grand-total");
    if (!kmInput || !rangeInput || !priceEl) return;

    if (enabled) {
      buildTravelScale();

      var rawVal = parseInt(kmInput.value, 10);
      var defaultKm = travelSteps.length ? travelSteps[0] : 1;
      var rounded = travelSteps.length ? roundToNearestStep(isNaN(rawVal) ? defaultKm : rawVal) : defaultKm;
      kmInput.value = rounded;
      kmInput.min = travelSteps[0] !== undefined ? travelSteps[0] : 1;
      kmInput.max = travelSteps.length ? travelSteps[travelSteps.length - 1] : 1000;

      var stepIndex = travelSteps.indexOf(rounded);
      if (stepIndex < 0) stepIndex = 0;
      rangeInput.min = 0;
      rangeInput.max = Math.max(0, travelSteps.length - 1);
      rangeInput.value = stepIndex;

      if (tooltipEl) {
        tooltipEl.textContent = rounded;
        var maxIdx = Math.max(0, travelSteps.length - 1);
        var pct = maxIdx > 0 ? (stepIndex / maxIdx) * 100 : 0;
        tooltipEl.style.left = pct + "%";
        tooltipEl.style.transform = pct <= 0 ? "translateX(-50%)" : pct >= 100 ? "translateX(-50%)" : "translateX(-50%)";
      }

      var v = getTravelVariantForKm(rounded);
      if (v) {
        priceEl.textContent = "+" + formatMoney(v.price);
        if (travelTotalEl) travelTotalEl.textContent = formatMoney(v.price);
      }
    }

    var productsSubtotal = totalPrice || 0;
    var v = enabled && kmInput ? getTravelVariantForKm(parseInt(kmInput.value, 10) || travelSteps[0]) : null;
    var travelCents = enabled && v ? v.price : 0;
    var installationFeeCents = 0;
    if (enabled && travelWrap && travelWrap.dataset.installationFeeId && travelWrap.dataset.installationFeePrice) {
      installationFeeCents = parseInt(travelWrap.dataset.installationFeePrice, 10) || 0;
    }
    var grandCents = (productsSubtotal * 100) + travelCents + installationFeeCents;
    if (productsSubtotalEl) productsSubtotalEl.textContent = formatMoney(productsSubtotal * 100);
    if (travelTotalEl) travelTotalEl.textContent = enabled && v ? formatMoney(v.price) : "0,00 €";
    var installationFeeEl = travelWrap && travelWrap.querySelector(".js-installation-fee-total");
    if (installationFeeEl) installationFeeEl.textContent = enabled && installationFeeCents > 0 ? formatMoney(installationFeeCents) : "0,00 €";
    if (grandTotalEl) grandTotalEl.textContent = formatMoney(grandCents);

    var totalCount = 0;
    document.querySelectorAll(".product-selection-wrap .product-card").forEach(function(card) {
      var block = card.closest(".facility-block");
      if (block && block.classList.contains("facility-block--hidden")) return;
      var qty = parseInt(card.querySelector("input.reset") ? card.querySelector("input.reset").value : 0, 10) || 0;
      totalCount += qty;
    });
    if (totalCount > 0 && addToCartBtn && addToCartBtnText) {
      var discountAmount = (productsSubtotal * discount) / 100;
      var discountedPrice = productsSubtotal - discountAmount;
      var displayPrice = discountedPrice + (travelCents / 100) + (installationFeeCents / 100);
      addToCartBtn.disabled = false;
      addToCartBtn.classList.remove("disabled");
      var addCartLbl = (window.productMixTranslations && window.productMixTranslations.add_to_cart_with_price) || "Add to cart –";
      if (discount > 0) {
        addToCartBtnText.innerHTML = "<strong>" + addCartLbl + " " + displayPrice.toFixed(2) + "€</strong><span class=\"old-price\">" + productsSubtotal.toFixed(2) + "€</span>";
      } else {
        addToCartBtnText.innerHTML = "<strong>" + addCartLbl + " " + displayPrice.toFixed(2) + "€</strong>";
      }
    }
  }

  if (travelWrap) {
    if (travelCheckbox) {
      travelCheckbox.addEventListener("change", function() {
        if (travelContent) {
          travelContent.hidden = !this.checked;
        }
        updateTravelExpense();
        if (typeof updateSummary === "function") {
          updateSummary();
        }
      });
    }
    var kmInput = travelWrap.querySelector(".js-travel-km-input");
    var rangeInput = travelWrap.querySelector(".js-travel-range");
    if (kmInput) {
      kmInput.addEventListener("input", function() {
        var v = parseInt(this.value, 10);
        if (!isNaN(v)) {
          var rounded = roundToNearestStep(v);
          this.value = rounded;
          var idx = travelSteps.indexOf(rounded);
          if (rangeInput && idx >= 0) rangeInput.value = idx;
        }
        updateTravelExpense();
      });
    }
    if (rangeInput) {
      rangeInput.addEventListener("input", function() {
        var idx = parseInt(this.value, 10);
        var km = travelSteps[idx] !== undefined ? travelSteps[idx] : travelSteps[0];
        if (kmInput) kmInput.value = km;
        updateTravelExpense();
      });
    }
    updateTravelExpense();
  }

function updateSummary() {
  let totalCount = 0;
  totalPrice = 0;
  summaryList.innerHTML = "";

  document.querySelectorAll(".product-selection-wrap .product-card").forEach(card => {
    var block = card.closest(".facility-block");
    if (block && block.classList.contains("facility-block--hidden")) return;
    const input = card.querySelector("input.reset");
    const qty = parseInt(input.value) || 0;

    const minusBtn = card.querySelector(".js-minus");
    const qtyInput = card.querySelector("input.reset");

    if (qty > 0) {
      minusBtn.style.display = "inline-flex";
      qtyInput.style.display = "inline-block";
    } else {
      minusBtn.style.display = "none";
      qtyInput.style.display = "none";
    }

    if (qty > 0) {
      const title = card.querySelector(".mix-bundle-title").innerText.trim();
      const priceText = card.querySelector(".price-quantity-wrap p").innerText.replace(/[^0-9.,]/g, '');
      const price = parseFloat(priceText.replace(',', '.'));
      const imgEl = card.querySelector(".js-product-card-img") || card.querySelector(".prd-media-img-wrap img") || card.querySelector("img");
      const img = imgEl ? imgEl.getAttribute("src") : "";
      const itemTotal = price * qty;

      totalCount += qty;
      totalPrice += itemTotal;

      const summaryItem = document.createElement("div");
      summaryItem.className = "list-image-content summary-item";
      summaryItem.dataset.variantId = card.dataset.variantId;

      summaryItem.innerHTML = `
        <img src="${img}" width="50" height="50" />
        <div class="summary-details">
          <p><strong>${title}</strong></p>
          <div class="quantity-price">
            <p class="summary-price">${qty} × ${price.toFixed(2)} €</p>
            <div class="summary-qty-controls">
              <button class="reset js-minus-summary">-</button>
              <input type="text" class="reset summary-input" value="${qty}" min="0" />
              <button class="reset js-plus-summary">+</button>
            </div>
          </div>
        </div>
      `;
      summaryList.appendChild(summaryItem);
    }
  });

  totalCountEl.textContent = totalCount;
  mtotalCountEl.textContent = totalCount;

  bundleSteps.forEach(step => {
    const stepNumber = parseInt(step.getAttribute("data-bundel-step"));
    if (totalCount >= stepNumber) {
      step.classList.remove("hidden");
    }
  });


  const bundleProgressSteps = document.querySelectorAll(".bundle-step, [data-bundel-step]");
  bundleProgressSteps.forEach((step, index) => {
    if (totalCount > index) {
      step.classList.add("active");
    } else {
      step.classList.remove("active");
    }
  });

  if (totalCount >= 4) discount = 15;
  else if (totalCount === 3) discount = 10;
  else if (totalCount === 2) discount = 5;
  else discount = 5;

  discount = 0

  const discountAmount = (totalPrice * discount) / 100;
  const discountedPrice = totalPrice - discountAmount;


  discountText.innerHTML = `<strong>-${discount}%</strong>`;
  if (totalCount >= 2) {
    var t = window.productMixTranslations || {};
    discountInfo.innerHTML = (t.you_saving || "You're saving") + " <strong>" + discount + "%</strong> " + (t.on_your_pack || "on your pack!");
  } else {
    var t2 = window.productMixTranslations || {};
    discountInfo.innerHTML = (t2.add_min_2_to_get || "Add at least 2 products to") + " <strong>" + (t2.get || "get :") + "</strong>";
  }

  if (totalCount === 0) {
    addToCartBtn.disabled = true;
    addToCartBtn.classList.add("disabled");
    addToCartBtnText.textContent = (window.productMixTranslations && window.productMixTranslations.add_1_product) || "ADD 1 PRODUCT";
  } else {
    addToCartBtn.disabled = false;
    addToCartBtn.classList.remove("disabled");

    var displayPrice = discountedPrice;
    if (travelWrap && isTravelExpenseEnabled()) {
      var kmInput = travelWrap.querySelector(".js-travel-km-input");
      var km = parseInt(kmInput ? kmInput.value : 20, 10) || 20;
      var tv = getTravelVariantForKm(km);
      if (tv) displayPrice += tv.price / 100;
      var instFeePrice = parseInt(travelWrap.dataset.installationFeePrice, 10) || 0;
      if (instFeePrice > 0) displayPrice += instFeePrice / 100;
    }

    var t = window.productMixTranslations || {};
    var addCartLabel = t.add_to_cart_with_price || "Add to cart –";
    if (discount > 0) {
      addToCartBtnText.innerHTML = "<strong>" + addCartLabel + " " + displayPrice.toFixed(2) + "€</strong><span class=\"old-price\">" + totalPrice.toFixed(2) + "€</span>";
    } else {
      addToCartBtnText.innerHTML = "<strong>" + addCartLabel + " " + displayPrice.toFixed(2) + "€</strong>";
    }
  }

  bindSummaryControls();

  if (typeof updateTravelExpense === "function") {
    updateTravelExpense();
  }
}
  function bindSummaryControls() {
    document.querySelectorAll(".js-plus-summary").forEach(btn => {
      btn.addEventListener("click", function() {
        const parent = this.closest(".summary-item");
        const variantId = parent.dataset.variantId;
        const input = parent.querySelector(".summary-input");
        let val = parseInt(input.value) || 0;
        input.value = val + 1;
        const mainInput = document.querySelector(`.product-selection-wrap .product-card[data-variant-id="${variantId}"] input.reset`);
        mainInput.value = parseInt(mainInput.value) + 1;
        updateSummary();
      });
    });

    document.querySelectorAll(".js-minus-summary").forEach(btn => {
      btn.addEventListener("click", function() {
        const parent = this.closest(".summary-item");
        const variantId = parent.dataset.variantId;
        const input = parent.querySelector(".summary-input");
        let val = parseInt(input.value) || 0;
        if (val > 0) input.value = val - 1;
        const mainInput = document.querySelector(`.product-selection-wrap .product-card[data-variant-id="${variantId}"] input.reset`);
        mainInput.value = Math.max(parseInt(mainInput.value) - 1, 0);
        updateSummary();
      });
    });
  }

  plusButtons.forEach(btn => {
    btn.addEventListener("click", function() {
      const input = this.parentElement.querySelector("input.reset");
      let val = parseInt(input.value) || 0;
      input.value = val + 1;
      updateSummary();
    });
  });

  minusButtons.forEach(btn => {
    btn.addEventListener("click", function() {
      const input = this.parentElement.querySelector("input.reset");
      let val = parseInt(input.value) || 0;
      if (val > 0) input.value = val - 1;
      updateSummary();
    });
  });

  document.querySelectorAll(".product-card .js-product-card-data").forEach(function(script) {
    var card = script.closest(".product-card");
    if (card) initProductCardOptions(card);
  });

  addToCartBtn.addEventListener("click", function(e) {
    e.preventDefault();

    const productMix = addToCartBtn.closest(".product-mix");
    const facilityRadio = productMix?.querySelector(
      '.product-mix-step[data-step="2"] .facility-type-selector__radio:checked'
    );
    const facilityType = facilityRadio ? facilityRadio.value : "";

    const selectedProducts = [];
    const collectionsEl = productMix?.querySelector(".product-selection-wrap");
    if (!collectionsEl) return;
    collectionsEl.querySelectorAll(".product-card").forEach(card => {
      var block = card.closest(".facility-block");
      if (block && block.classList.contains("facility-block--hidden")) return;
      const qty = parseInt(card.querySelector("input.reset").value) || 0;
      if (qty > 0) {
        const variantId = parseInt(card.dataset.variantId, 10) || card.dataset.variantId;
        const properties = {
          "_bundle_pack": "Custom Mix",
          "_bundle_discount": discount + "%"
        };
        if (facilityType) {
          properties["Facility type"] = facilityType;
        }
        selectedProducts.push({
          id: variantId,
          quantity: qty,
          properties: properties
        });
      }
    });

    if (selectedProducts.length === 0) return;

    if (travelWrap && isTravelExpenseEnabled()) {
      var kmInput = travelWrap.querySelector(".js-travel-km-input");
      var km = parseInt(kmInput ? kmInput.value : 20, 10) || 20;
      var tv = getTravelVariantForKm(km);
      if (tv) {
        selectedProducts.push({
          id: tv.id,
          quantity: 1,
          properties: { "_travel_expense": km + " km" }
        });
      }
      var installationFeeId = travelWrap.dataset.installationFeeId;
      if (installationFeeId) {
        selectedProducts.push({
          id: parseInt(installationFeeId, 10),
          quantity: 1,
          properties: { "_installation_fee": "Installation" }
        });
      }
    }

    addToCartBtn.disabled = true;
    addToCartBtnText.textContent = (window.productMixTranslations && window.productMixTranslations.adding) || "Adding...";
    addToCartBtn.classList.add("loading");

    var cartItems = selectedProducts.map(function(p) {
      return { id: p.id, quantity: p.quantity, properties: p.properties };
    });

    fetch("/cart/clear.js", { method: "POST" })
      .then(function() {
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: cartItems })
        });
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.status && data.status >= 400) throw new Error(data.message || ((window.productMixTranslations && window.productMixTranslations.add_to_cart_failed) || "Add to cart failed"));
        window.location.href = "/checkout";
      })
      .catch(function(err) {
        console.error("Cart error:", err);
        addToCartBtn.disabled = false;
        addToCartBtnText.textContent = (window.productMixTranslations && window.productMixTranslations.add_to_cart) || "Add to cart";
        addToCartBtn.classList.remove("loading");
      });
  });
});

document.addEventListener('click', function(e) {
  const btn = e.target.closest('.button.edit-pack');
  const hideBtn = e.target.closest('.js-hide-modal');
  const summary = document.querySelector('.travel-expense-wrap');
  const travel_expense = document.querySelector('.summary-content-wrap');
  const summary_btn = document.querySelector('button.nws-submit-btn');
  
  if (btn) {
    btn.classList.toggle('active');
    summary?.classList.toggle('active');
    travel_expense?.classList.toggle('active');
    summary_btn?.classList.toggle('active');
    document.querySelector('html').style.overflow = 'hidden';
  }

  if (hideBtn) {
    document.querySelectorAll('.button.edit-pack.active').forEach(el => el.classList.remove('active'));
    document.querySelector('html').style.overflow = '';
    summary?.classList.remove('active');
    travel_expense?.classList.remove('active');
    summary_btn?.classList.remove('active');
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const drawer = document.querySelector('#product-drawer');
  const overlay = drawer.querySelector('.drawer-overlay');
  const closeBtn = drawer.querySelector('.drawer-close');
  const titleEl = drawer.querySelector('.drawer-title');
  const body = document.body;
  let activeTrigger = null;

function openDrawer(trigger) {
  const productId = trigger.getAttribute('data-product-id');
  const productContent = document.querySelector(`#drawer-product-${productId}`);

  if (!productContent) {
    console.warn('No product content found for this ID');
    return;
  }

  const drawerBody = drawer.querySelector('.drawer-body');
  drawerBody.innerHTML = productContent.innerHTML;

  drawer.classList.add('active');
  body.style.overflow = 'hidden';
  document.querySelector('html').style.overflow = 'hidden';
  activeTrigger = trigger;
  trigger.classList.add('active');
}


  function closeDrawer() {
    drawer.classList.remove('active');
    body.style.overflow = '';
    document.querySelector('html').style.overflow = '';
    if (activeTrigger) activeTrigger.classList.remove('active');
    activeTrigger = null;
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.js-show-modal-product');
    const insideDrawer = e.target.closest('.drawer-panel');

    if (btn) {

      if (drawer.classList.contains('active') && activeTrigger === btn) {
        closeDrawer();
      } else {
        closeDrawer();
        openDrawer(btn);
      }
      return;
    }

    if (insideDrawer) return;

    if (drawer.classList.contains('active') && e.target.closest('.drawer-overlay')) {
      closeDrawer();
    }
  });

  closeBtn.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('active')) {
      closeDrawer();
    }
  });
});

document.addEventListener('click', function(e) {
  if (e.target.closest('.drawer-cart-btn')) {
    setTimeout(function() {
      const drawerClose = document.querySelector('.drawer-close');
      if (drawerClose) drawerClose.click();
    }, 800);
  }
});



document.addEventListener('click', function (event) {
  if (event.target.closest('.drawer-cart-btn')) {
    const button = event.target.closest('.drawer-cart-btn');
    const productId = button.getAttribute('data-product-id');

    const targetCard = document.querySelector(
      `.product-selection-wrap .product-card[data-variant-id="${productId}"], .product-selection-wrap .product-card[data-product-id="${productId}"]`
    );

    if (targetCard) {
      const plusBtn = targetCard.querySelector('.js-plus');
      if (plusBtn) plusBtn.click();
    }
  }
});